<template>
  <div class="modal-card cp-confirm-modal" style="width: auto">
    <header class="modal-card-head cp-confirm-modal-head">
      <p class="modal-card-title">{{ title }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body cp-confirm-modal-button-section">
      <button class="button is-primary cp-confirm-modal-ok-button" @click="handleOk">
        {{ ok }}
      </button>
      <button class="button cp-confirm-modal-cancel-button" type="button" @click="$emit('close')">
        {{ cancel }}
      </button>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    title: {
      type: String,
    },
    ok: {
      type: String,
    },
    cancel: {
      type: String,
    },
  },
  methods: {
    handleOk() {
      this.$emit('close');
      this.$emit('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-confirm-modal {
  width: 500px !important;

  &-head {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  &-button-section {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-ok-button {
    width: 100px;
  }
  &-cancel-button {
    width: 100px;
    margin-left: 20px;
  }
}
</style>
